import { addDaysToDate } from 'utils/date'

const toDoCards = [
  {
    healthPlan: true,
    name: 'Plano de saúde - Bradesco',
    date: addDaysToDate(30),
    clientName: 'Cliente RH B',
    familyName: 'movimentation',
  },
]

const toDoCardsBuyer = [
  {
    healthPlan: false,
    name: 'Seguro de vida - Mapfre',
    date: '08/07/2024',
    clientName: 'Corretora',
    familyName: 'quotation',
  },
]

const initializedCards = [
  {
    healthPlan: true,
    name: 'Plano de saúde - SulAmerica',
    date: '08/07/2024',
    clientName: 'Cliente RH A',
    familyName: 'movimentation',
  },
]

const initializedCardsBuyer = [
  {
    healthPlan: true,
    name: 'Plano de saúde - SulAmerica',
    date: '08/07/2024',
    clientName: 'Corretora',
    familyName: 'implantation',
  },
]

const finalizedCards = [
  {
    healthPlan: true,
    name: 'Plano de saúde - SulAmerica',
    date: '08/07/2024',
    clientName: 'Cliente RH A',
    familyName: 'implantation',
  },
  {
    healthPlan: false,
    name: 'Seguro de vida',
    date: '08/07/2024',
    clientName: 'Cliente RH B',
    familyName: 'implantation',
  },
]

const finalizedCardsBuyer = [
  {
    healthPlan: true,
    name: 'Odonto - Metlife',
    date: '08/07/2024',
    clientName: 'Corretora',
    familyName: 'implantation',
  },
]

export { finalizedCards, finalizedCardsBuyer, initializedCards, initializedCardsBuyer, toDoCards, toDoCardsBuyer }
